var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 27 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 38.1328H8.7825L8.5725 37.9303C9.3075 37.0753 9.75 35.9653 9.75 34.7578C9.75 32.0653 7.5675 29.8828 4.875 29.8828C2.1825 29.8828 0 32.0653 0 34.7578C0 37.4503 2.1825 39.6328 4.875 39.6328C6.0825 39.6328 7.1925 39.1903 8.0475 38.4553L8.25 38.6653V39.2578L12 43.0003L13.1175 41.8828L9.375 38.1328ZM4.875 38.1328C3.0075 38.1328 1.5 36.6253 1.5 34.7578C1.5 32.8903 3.0075 31.3828 4.875 31.3828C6.7425 31.3828 8.25 32.8903 8.25 34.7578C8.25 36.6253 6.7425 38.1328 4.875 38.1328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2eb0584c43eac9efe7f21a5ecd9b39e9.svg";
export { ForwardRef as ReactComponent };